import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSlickpicComponent } from './simple-icons-slickpic.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSlickpicComponent ],
    exports:      [ SimpleIconsSlickpicComponent ],
    bootstrap:    []
})
export class SimpleIconsSlickpicModule {}
